const data = {
  v: "5.3.4",
  fr: 24,
  ip: 0,
  op: 72,
  w: 200,
  h: 200,
  nm: "User",
  ddd: 0,
  assets: [
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [3],
                  e: [-2],
                },
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 13,
                  s: [-2],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.667] },
                  n: ["0p36_1_0p167_0p667"],
                  t: 0,
                  s: [8],
                  e: [6],
                },
                {
                  i: { x: [0.833], y: [0.966] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_0p966_0p167_0"],
                  t: 12,
                  s: [6],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [-0.079] },
                  n: ["0p833_1_0p167_-0p079"],
                  t: 25,
                  s: [-7],
                  e: [0],
                },
                { t: 41 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.127 },
                  n: "0p36_1_0p167_0p127",
                  t: 0,
                  s: [101.055, 190.62, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -9.29166698455811, 0],
                  ti: [0, 9.29166698455811, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
    {
      id: "comp_1",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [-5],
                  e: [3],
                },
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 13,
                  s: [3],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.089] },
                  n: ["0p36_1_0p167_0p089"],
                  t: 0,
                  s: [8],
                  e: [-7],
                },
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p36_1_0p167_0"],
                  t: 12,
                  s: [-7],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1_0p167_0"],
                  t: 16,
                  s: [-7],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.167 },
                  n: "0p36_1_0p167_0p167",
                  t: 0,
                  s: [101.055, 177.37, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -7.08333349227905, 0],
                  ti: [0, 7.08333349227905, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
    {
      id: "comp_2",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [-5],
                  e: [0],
                },
                { t: 13 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.1405, 0.5773, 0.9595, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.089] },
                  n: ["0p36_1_0p167_0p089"],
                  t: 0,
                  s: [8],
                  e: [-7],
                },
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p36_1_0p167_0"],
                  t: 12,
                  s: [-7],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1.067] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1p067_0p167_0"],
                  t: 16,
                  s: [-7],
                  e: [6],
                },
                {
                  i: { x: [0.833], y: [0.872] },
                  o: { x: [0.167], y: [0.028] },
                  n: ["0p833_0p872_0p167_0p028"],
                  t: 30,
                  s: [6],
                  e: [-16],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [-0.846] },
                  n: ["0p833_1_0p167_-0p846"],
                  t: 40,
                  s: [-16],
                  e: [-16],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1_0p167_0"],
                  t: 43,
                  s: [-16],
                  e: [0],
                },
                { t: 53 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.167 },
                  n: "0p36_1_0p167_0p167",
                  t: 0,
                  s: [101.055, 177.37, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -7.08333349227905, 0],
                  ti: [0, 7.08333349227905, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.1405, 0.5773, 0.9595, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "Right User 3",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [159, 50.24999999999999, 0], ix: 2 },
        a: { a: 0, k: [100, 100, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 200,
      h: 200,
      ip: 21,
      op: 152,
      st: 21,
      bm: 0,
      completed: true,
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [3],
                  e: [-2],
                },
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 13,
                  s: [-2],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.667] },
                  n: ["0p36_1_0p167_0p667"],
                  t: 0,
                  s: [8],
                  e: [6],
                },
                {
                  i: { x: [0.833], y: [0.966] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_0p966_0p167_0"],
                  t: 12,
                  s: [6],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [-0.079] },
                  n: ["0p833_1_0p167_-0p079"],
                  t: 25,
                  s: [-7],
                  e: [0],
                },
                { t: 41 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.127 },
                  n: "0p36_1_0p167_0p127",
                  t: 0,
                  s: [101.055, 190.62, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -9.29166698455811, 0],
                  ti: [0, 9.29166698455811, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: "Left User 2",
      refId: "comp_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [39.5, 52.5, 0], ix: 2 },
        a: { a: 0, k: [100, 100, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 200,
      h: 200,
      ip: 8,
      op: 139,
      st: 8,
      bm: 0,
      completed: true,
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [-5],
                  e: [3],
                },
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 13,
                  s: [3],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.089] },
                  n: ["0p36_1_0p167_0p089"],
                  t: 0,
                  s: [8],
                  e: [-7],
                },
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p36_1_0p167_0"],
                  t: 12,
                  s: [-7],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1_0p167_0"],
                  t: 16,
                  s: [-7],
                  e: [0],
                },
                { t: 30 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.167 },
                  n: "0p36_1_0p167_0p167",
                  t: 0,
                  s: [101.055, 177.37, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -7.08333349227905, 0],
                  ti: [0, 7.08333349227905, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.0667, 0.2863, 0.4824, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
    {
      ddd: 0,
      ind: 3,
      ty: 0,
      nm: "Center User",
      refId: "comp_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [100, 100, 0], ix: 2 },
        a: { a: 0, k: [100, 100, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 200,
      h: 200,
      ip: 0,
      op: 131,
      st: 0,
      bm: 0,
      completed: true,
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 1",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [100, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ty: "rc",
                  d: 1,
                  s: { a: 0, k: [72.243, 31.904], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: "Rectangle Path 1",
                  mn: "ADBE Vector Shape - Rect",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.19, 48.844], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Rectangle 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "User Outlines 2",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.37], y: [1] },
                  o: { x: [0.333], y: [0] },
                  n: ["0p37_1_0p333_0"],
                  t: 1,
                  s: [-5],
                  e: [0],
                },
                { t: 13 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.37, y: 1 },
                  o: { x: 0.333, y: 0 },
                  n: "0p37_1_0p333_0",
                  t: 1,
                  s: [101.055, 192.877, 0],
                  e: [101.055, 162.127, 0],
                  to: [0, -5.125, 0],
                  ti: [0, 5.125, 0],
                },
                { t: 13 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 132.84, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [-18.195, 8.251],
                        [28.805, 14.880999999999998],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [10.462, 14.035],
                        [-23.058, 16.464999999999996],
                        [-24.715, 33.004],
                      ],
                      o: [
                        [-30.609, 33.004],
                        [-28.805, 14.881],
                        [18.197000000000003, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [23.059, 16.465],
                        [-10.46, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      v: [
                        [-30.609, 33.004],
                        [-30.094, 26.963],
                        [0.001, 8.251],
                        [30.094, 26.926],
                        [30.609, 33.004],
                        [24.717, 33.004],
                        [24.201, 27.479],
                        [0.001, 14.035],
                        [-24.199, 27.516],
                        [-24.715, 33.004],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 3",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.1405, 0.5773, 0.9595, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Group 1",
              np: 2,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Shape Layer 3",
          td: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [90.375, 100, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [45.09, 45.09], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [0.09, 0.5273, 0.91, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 0, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  ml2: { a: 0, k: 4, ix: 8 },
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.904, 0.9531, 0.996, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [10.864, 16.235], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "User Outlines",
          tt: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0.089] },
                  n: ["0p36_1_0p167_0p089"],
                  t: 0,
                  s: [8],
                  e: [-7],
                },
                {
                  i: { x: [0.36], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p36_1_0p167_0"],
                  t: 12,
                  s: [-7],
                  e: [-7],
                },
                {
                  i: { x: [0.833], y: [1.067] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1p067_0p167_0"],
                  t: 16,
                  s: [-7],
                  e: [6],
                },
                {
                  i: { x: [0.833], y: [0.872] },
                  o: { x: [0.167], y: [0.028] },
                  n: ["0p833_0p872_0p167_0p028"],
                  t: 30,
                  s: [6],
                  e: [-16],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [-0.846] },
                  n: ["0p833_1_0p167_-0p846"],
                  t: 40,
                  s: [-16],
                  e: [-16],
                },
                {
                  i: { x: [0.833], y: [1] },
                  o: { x: [0.167], y: [0] },
                  n: ["0p833_1_0p167_0"],
                  t: 43,
                  s: [-16],
                  e: [0],
                },
                { t: 53 },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.36, y: 1 },
                  o: { x: 0.167, y: 0.167 },
                  n: "0p36_1_0p167_0p167",
                  t: 0,
                  s: [101.055, 177.37, 0],
                  e: [101.055, 134.87, 0],
                  to: [0, -7.08333349227905, 0],
                  ti: [0, 7.08333349227905, 0],
                },
                { t: 12 },
              ],
              ix: 2,
            },
            a: { a: 0, k: [99.789, 103.373, 0], ix: 1 },
            s: { a: 0, k: [92.5, 92.5, 100], ix: 6 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-10.755, -22.137],
                        [-6.151, -2.172],
                        [10.757, -8.251],
                        [5.71, -27.295],
                      ],
                      o: [
                        [-10.755, -8.251],
                        [6.152, -2.172],
                        [10.757, -22.137],
                        [-5.707999999999999, -27.295],
                      ],
                      v: [
                        [-10.755, -16.317],
                        [0.001, -2.172],
                        [10.757, -16.317],
                        [0.001, -27.295],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-16.501, -5.009],
                        [-8.950000000000001, -33.004],
                        [16.503, -25.341],
                        [9.392999999999999, 3.537],
                      ],
                      o: [
                        [-16.501, -25.341],
                        [8.952, -33.004],
                        [16.503, -5.009],
                        [-9.392000000000001, 3.537],
                      ],
                      v: [
                        [-16.501, -16.317],
                        [0.001, -33.004],
                        [16.503, -16.317],
                        [0.001, 3.537],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "Path 2",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "fl",
                  c: { a: 0, k: [0.1405, 0.5773, 0.9595, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: "Fill 1",
                  mn: "ADBE Vector Graphic - Fill",
                  hd: false,
                  _render: true,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [99.789, 99.836], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                  _render: true,
                },
              ],
              nm: "Group 1",
              np: 3,
              cix: 2,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
              _render: true,
            },
          ],
          ip: 0,
          op: 131,
          st: 0,
          bm: 0,
          completed: true,
        },
      ],
    },
  ],
  markers: [],
  __complete: true,
};

export default data;
